import React from 'react';

const WhyChooseUs = () => {
    const reasons = [
        {
            icon: 'fa-infinity',
            title: 'End-to-End Delivery',
            desc: 'From discovery to managed services — we handle the complete journey of your digital transformation.'
        },
        {
            icon: 'fa-puzzle-piece',
            title: 'Technology-Agnostic',
            desc: 'Solutions tailored to your environment, not locked into specific vendors or platforms.'
        },
        {
            icon: 'fa-bolt',
            title: 'Fast Prototyping',
            desc: 'Reduce risk and show value early with rapid prototyping and iterative development.'
        }
    ];

    return (
        <section style={{ padding: '80px 0', backgroundColor: '#0C1A36' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <h2 style={{
                        fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                        fontWeight: 'bold',
                        color: 'white',
                        marginBottom: '16px'
                    }}>
                        Why Choose Us
                    </h2>
                    <div style={{
                        width: '80px',
                        height: '4px',
                        backgroundColor: '#1746A2',
                        margin: '0 auto'
                    }}></div>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                    gap: '32px'
                }}>
                    {reasons.map((reason, index) => (
                        <div
                            key={index}
                            style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                backdropFilter: 'blur(8px)',
                                borderRadius: '12px',
                                padding: '32px',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                textAlign: 'center'
                            }}
                        >
                            <div style={{
                                width: '64px',
                                height: '64px',
                                backgroundColor: '#1746A2',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 24px'
                            }}>
                                <i className={`fas ${reason.icon}`} style={{
                                    fontSize: '28px',
                                    color: 'white'
                                }}></i>
                            </div>
                            <h3 style={{
                                fontSize: '20px',
                                fontWeight: 'bold',
                                color: 'white',
                                marginBottom: '16px'
                            }}>
                                {reason.title}
                            </h3>
                            <p style={{ color: '#d1d5db', lineHeight: 1.6 }}>
                                {reason.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;